module.exports = __webpack_public_path__ + "img/24.3b70796.png";